import {axiPayment} from '@shared/api';
import {validateData} from '@shared/utils';
import {ManagedMethod, ManagedMethodKind} from '../types';
import {v8nSchemaOfListManagedMethodsResponse} from './backendSchemas';
import {ListManagedMethodsResponse} from './backendTypes';
import {mapManagedMethodFromBackend} from './dataMappers';

const KIND_PATH: Record<ManagedMethodKind, string> = {
  [ManagedMethodKind.deposit]: 'payment-methods',
  [ManagedMethodKind.payout]: 'payout-methods',
};

export const getManagedMethods = async (
  kind: ManagedMethodKind,
): Promise<ManagedMethod[]> => {
  const response = await axiPayment.get<ListManagedMethodsResponse>(
    `/admin/${KIND_PATH[kind]}`,
  );

  try {
    validateData(
      response.data,
      v8nSchemaOfListManagedMethodsResponse,
      'getManagedMethods',
    );
  } catch {
    //
  }

  return (response.data?.array ?? []).map(item =>
    mapManagedMethodFromBackend(item),
  );
};

export interface UpdateManagedMethodParams {
  kind: ManagedMethodKind;
  id: string;
  enabled?: boolean;
  sortOrder?: number;
}

export const updateManagedMethod = async ({
  kind,
  id,
  enabled,
  sortOrder,
}: UpdateManagedMethodParams): Promise<void> => {
  await axiPayment.patch(`/admin/${KIND_PATH[kind]}/${id}`, {
    ...(enabled !== undefined && {enabled}),
    ...(sortOrder !== undefined && {sort_order: sortOrder}),
  });
};
